import { CommonModule } from '@angular/common';
import { Component, computed, Injector, input, OnInit, output, signal } from '@angular/core';
import { toObservable } from '@angular/core/rxjs-interop';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CalendarPickerComponent } from '../../../../../../shared/components/forms/calendar-picker/calendar-picker.component';
import { RadioButtonComponent } from '../../../../../../shared/components/forms/radio-button/radio-button.component';
import { TextAreaComponent } from '../../../../../../shared/components/forms/text-area/text-area.component';
import { TextSearchComponent } from '../../../../../../shared/components/forms/text-search/text-search.component';
import { templateDrivenFormsViewProviders } from '../../../../../../shared/directives/form.directive';
import { getErrorsFromSubmission } from '../../../../../orbit/book-claim/components/orbit-claims-form/pipes/error-subscription';
import { OrbitFormClaimService } from '../../../../../orbit/book-claim/services/orbit-form-claim.service';
import { doesFormPassValidations } from '../../pipes/form-validation.pipe';

@Component({
  selector: 'app-generic-form-handler',
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    TextSearchComponent,
    RadioButtonComponent,
    CalendarPickerComponent,
    TextAreaComponent,
  ],
  standalone: true,
  templateUrl: './generic-form-handler.component.html',
  styleUrl: './generic-form-handler.component.scss',
  viewProviders: [templateDrivenFormsViewProviders],
  host: {
    class: 'full-width',
  },
})
export class GenericFormHandlerComponent implements OnInit {
  currentStep = input.required<string>();
  formValue = input.required<Record<string, any>>();
  submittingValue = input.required<boolean>();
  formSubmitted = input.required<boolean>();
  activeStep = input.required<any>();
  formValid = output<boolean>();
  loadingData = output<boolean>();

  valid = signal(false);
  todaysDate = new Date();

  validationMessage: string | undefined;

  private readonly viewModel = computed(() => {
    return {
      submittingValue: this.submittingValue(),
      formValue: this.formValue(),
      formSubmitted: this.formSubmitted(),
      formValid: this.valid(),
      currentStep: this.currentStep(),
      activeStep: this.activeStep(),
      submittingResource: this.orbitFormClaimService.formSubmission,
    };
  });

  get vm() {
    return this.viewModel();
  }

  constructor(
    private readonly injector: Injector,
    private readonly orbitFormClaimService: OrbitFormClaimService
  ) {}

  ngOnInit(): void {
    this.validateForm();
    this.handleAPIErrors();
    setTimeout(() => {
      const existingInput = document.querySelector('input') ?? document.querySelector('textarea');
      existingInput?.focus();
    }, 50);
  }

  handleAPIErrors(): void {
    getErrorsFromSubmission(this.vm.submittingResource, this.injector, (attempts, error) => {
      console.log({ error });
    });
  }

  validateForm(): void {
    toObservable(this.formValue, { injector: this.injector })
      .pipe(doesFormPassValidations(this.vm.activeStep, { debounceTimer: 100 }))
      .subscribe({
        next: ({ valid, errors }) => {
          this.valid.set(valid);
          this.formValid.emit(valid);
          this.validationMessage = errors[0];
        },
      });
  }
}
